import { ELanguage } from '@web_opxp/language';

export const BUILD_ID_FALLBACK = 'local-build';

export const SKELETON_CLASSNAME = 'bp6-skeleton';

export const EDISON_ONBOARDING = 9;

export const SUBSCRIBE_AVAILABLE_LANGUAGES = [
  ELanguage.German,
  ELanguage.English,
  ELanguage.French,
  ELanguage.Russian,
  ELanguage.Japanese,
  ELanguage.Spanish,
  ELanguage.Italian,
  ELanguage.Polish,
];
